<template>
    <div class="cnoiltop">
        <div style="cursor: pointer" @click="goHome">{{message('返回首页', 'Return to Home Page')}}</div>
        <img src="@/assets/OilLogo.png" alt="" @click="goIndex">
        <div style="display: flex;align-items: center;">
            <!-- <div style="cursor: pointer" @click="goIndex" v-if="type == 'detail'">{{message('返回上一页', 'Return to previous page')}}</div> -->
            <!-- 目录抽屉 -->
            <div @click="DrawerVal = !DrawerVal"  v-if="type == 'detail' && catalogList.length > 0" style="cursor: pointer;">
                <Icon type="ios-menu-outline" style="font-size: 4.5vh;"/>
            </div>

            <Drawer placement="right" v-model="DrawerVal" class="drawers" :class="{drawersTop: type == 'detail'}">
                <div class="contain">
                    <div v-for="(item, index) in catalogList" :key="index" class="catalogueItem" @click="goAnother(index)">
                        <div>{{item.Keywords}}</div>
                    </div>
                    <div class="selectMore" @click="showLanguage = !showLanguage" v-if="false">
                        <Icon type="ios-arrow-down" class="moreIcon"/>
                        <div >{{message('选择语言', 'Choose Language')}}</div>
                    </div>
                    <div v-if="showLanguage" class="selectList">
                        <div v-for="(item, index) in language" :key="index" class="selectItem" :class="{selected: selectedLanguage == item.value}" @click="changeLanguage(item.value)">{{ item.value }}</div>
                    </div>
                </div>
            </Drawer>


            <!-- <Select v-model="selectedLanguage" style="width:100px" class="langSelect" @on-change="changeLanguage" v-if="false">
                <Option v-for="item in language" :value="item.value" :key="item.value" >{{ item.label }}</Option>
            </Select> -->
        </div>
    </div>
</template>

<script>
import {
	mapState,
	mapMutations,
} from 'vuex'

export default ({
    data() {
        return {
            selectedLanguage: 'ZH',
            showLanguage: false,
            language:[
                {value: 'ZH', label: '简体中文'},
                {value: 'EN', label: 'English'}
            ],
            // 目录
            DrawerVal: false
        }
    },
    watch: {
    },
    props: {
        type: {
            type: String,
            default: 'index'
        },
        catalogList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
	created() {
        this.$nextTick(function() {
			this.initData()
		})
	},
    computed: {
		...mapState({
            setLanguage: state => state.common.setLanguage,
		}),
	},
    methods: {
        ...mapMutations([
			"SET_LANGUAGE",
		]),

        async initData() {
            this.selectedLanguage = this.setLanguage
        },
        changeLanguage(val) {
            this.selectedLanguage = val
            this.SET_LANGUAGE(this.selectedLanguage)
            this.$emit('change-Language',this.selectedLanguage)

        },


        message(ZH,EN){
			if(this.selectedLanguage == 'ZH'){
				return ZH
			}
			return EN
		},
        goHome() {
            this.$router.push('/home')
        },
        goIndex() {
            if(this.type == 'index') {
                const upRoll = setInterval(() => {
                    const top = document.documentElement.scrollTop // 每次获取页面被卷去的部分
                    const speed = Math.ceil(top / 10) // 每次滚动多少 （步长值）
                    if (document.documentElement.scrollTop > 0) {
                        document.documentElement.scrollTop -= speed // 不在顶部 每次滚动到的位置
                    } else {
                        clearInterval(upRoll) // 回到顶部清除定时器
                    }
                }, 5)
            }else {
                this.$router.push('/cnoil')
                window.scrollTo(0, 0)
            }
        },
        goAnother(index) {
            let url = this.catalogList[index].Url
            location = url
            this.DrawerVal = false
            window.scrollTo(0, 0);
        }
    }
})
</script>

<style lang="scss" scoped>
@import "@/style/mixin";
@import "@/style/common";

.cnoiltop {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 7vh;
    width: 100%;
    padding: 0 2vw;
    background-color: #505d61;
    font-size: 14px;
    color: #fff;
    z-index: 100;
    img {
        height: 70%;
        object-fit: contain;
        width: 3.5vh;
        height: 3.5vh;
        @include center;
        cursor: pointer;
    }
    .langSelect {
        margin-left: 20px;
        background-color: transparent
    }
}

</style>


<style lang="scss">
    .cnoiltop {
        .ivu-select-selection {
            background-color: transparent;
            color: #fff;
            border: 1px solid transparent;
            .ivu-icon-ios-arrow-down:before {
                color: #fff;
            }
        }

    }
    .drawers {
        user-select: none;
        color: #000;

        .ivu-drawer-mask {
            background-color: rgba(0, 0, 0, 0.8);
        }
        .contain {
            cursor: pointer;
            font-size: 16px;
            text-align: center;
            margin-top: 5vh;
            .ivu-drawer-close .ivu-icon-ios-close {
                font-size: 54px !important;
            }
            .catalogueItem {
                padding: 10px 0;
            }
        }
        .ivu-icon-ios-close {
            font-size: 55px;
        }
        .selectMore {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 10px 0;
            .moreIcon {
                position: absolute;
                left: 40px;
            }
        }
        .selectList {
            
            .selectItem {
                margin: 10px 0;
                color: #949494;
            }
            .selected {
                color: #515a6e;
            }
        }

    }
    .drawersTop {
        .ivu-drawer-mask {
            top: 7vh;
        }
        .ivu-drawer {
            top: 7vh;
        }
        .ivu-drawer-wrap {
            top: 7vh;
        }
    }

</style>
